(function() {
  'use strict';

  var priceSimulator = {
    template: require('./price-simulator.html'),
    controller: 'PriceSimulatorCtrl',
    bindings: {
      zipCode: '<',
    },
  };

  angular
    .module('mandaeApp')
    .component('priceSimulator', priceSimulator);

}());
